import { render, staticRenderFns } from "./RailwayTourItem.vue?vue&type=template&id=7abb30f4&lang=pug&"
import script from "./RailwayTourItem.vue?vue&type=script&lang=ts&"
export * from "./RailwayTourItem.vue?vue&type=script&lang=ts&"
import style0 from "./RailwayTourItem.vue?vue&type=style&index=0&id=7abb30f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports